import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
  ActivatedRoute,
} from "@angular/router";

import { Observable } from "rxjs";

import { AuthService } from "../_services/auth.service";
import { TokenStorageService } from "../_services/token-storage.service";
import { ServicioGeneral } from "../_services/servicio-general.service";
import { NotificationReadService } from "../_services/notificacion-read.service";
import { Location } from "@angular/common";

import jwt_decode from "jwt-decode";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authservice: AuthService,
    private router: Router,
    private tokenService: TokenStorageService,
    private authService: AuthService,
    private notificacionesService: NotificationReadService,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let token = this.tokenService.getToken();

    if (token != null && this.tokenService.isPending2FAEnrollment()) {
      this.router.navigate(['login']);
      return false;
    }
   
    if (token != null) {
      var decodedToken: any = jwt_decode(token);
      var expired = Math.floor(new Date().getTime() / 1000) >= decodedToken.exp;
      if (expired) {
        // const user = this.tokenservice.getUser();
        //this.notificacionesService.updateNumeroAlertas();
        this.tokenService.signOutExpirationAndRedirectTo("login");
        window.location.reload();
        return false;
        
      } else {
/*         this.notificacionesService.updateAlertMap();
 */        const queryParams = state.root.queryParamMap;

        // Verificar si 'action' está presente en los queryParams
        if ("action" in queryParams) {
          this.location.replaceState(
            this.router.createUrlTree([], { queryParams: queryParams }).toString()
          );
        }
      }
    }else{
      let params ={route:this.getPreviousUrl(state)};
      this.router.navigate(["login"],{queryParams: params})
      return false;
    }
    return true;
  }
  private getPreviousUrl(routerState: RouterStateSnapshot): string {
    let route = routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    let url = route.url.toString();
    const queryParams = route.queryParams;
    if (Object.keys(queryParams).length > 0) {
      const queryString = Object.keys(queryParams)
        .map((key) => `${key}=${queryParams[key]}`)
        .join("&");
      url += `?${queryString}`;
    }

    return url;
  }
  /*

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if (!this.authService.getAuthStatus()) {
      return true;
    }

    this.router.navigate(['/home'])
    return false;
  }
  */
}
